import { createRouter as createTanStackRouter } from "@tanstack/react-router";
import { QueryClient } from "@tanstack/react-query";
import { routeTree } from "./routeTree.gen";

export function getRouter() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: { staleTime: 60_000 },
    },
  });

  // Cast: TanStack Router's createRouter has a compile-time guard that
  // requires strictNullChecks; this project keeps it off for now.
  const router = (createTanStackRouter as unknown as (opts: unknown) => unknown)({
    routeTree,
    context: { queryClient },
    defaultPreload: false,
    scrollRestoration: true,
  });

  return router as ReturnType<typeof createTanStackRouter<typeof routeTree>>;
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}

